import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IonPage } from '@ionic/react';
import styles from './Inbox.module.scss';
import InboxConversationList, { type InboxConversationSelectMeta } from '../components/InboxConversationList';

/**
 * The Inbox tab: the conversation list, and nothing else.
 *
 * Opening a conversation navigates to /tabs/inbox/:id, which RoleBasedTabs routes to
 * Conversation.tsx (a separate page). This page used to also contain its own conversation view
 * for that id; because Ionic keeps this page mounted while the new one slides in, it could
 * find the conversation (SMS ones, in particular) and draw that old screen first — an extra
 * screen popping in before the real conversation page. It never had any reason to render one,
 * so it no longer does.
 */
const Inbox: React.FC = () => {
  const navigate = useNavigate();
  // A handler whose identity never changes (it reaches the latest `navigate` through a ref), so the
  // memoised conversation list below isn't re-rendered each time this page re-renders.
  const navigateRef = useRef(navigate);
  useEffect(() => {
    navigateRef.current = navigate;
  });
  const handleSelectConversation = useCallback(
    (id: string, meta: InboxConversationSelectMeta) => navigateRef.current(`/tabs/inbox/${id}`, { state: meta }),
    []
  );

  return (
    <IonPage className={styles.page}>
      <InboxConversationList onSelectConversation={handleSelectConversation} />
    </IonPage>
  );
};

export default Inbox;
